import {Component, inject, Input, OnInit} from '@angular/core';
import { CommonModule } from '@angular/common';
import { AgGridAngular } from 'ag-grid-angular';
import {ColDef, GridOptions, GridReadyEvent, CellValueChangedEvent, GridApi} from 'ag-grid-community';
import { NzNotificationService } from 'ng-zorro-antd/notification';

import { CustomersService } from '../../../services/customers/customers.service';
import { Customer } from '../../../model/models';
import {CellEditorComponent} from "./cell-editor/cell-editor.component";
import {CellRendererComponent} from "./cell-renderer/cell-renderer.component";

@Component({
  selector: 'customer-locations',
  standalone: true,
  imports: [CommonModule, AgGridAngular],
  templateUrl: './customer-locations.component.html',
  styleUrl: './customer-locations.component.scss'
})
export class CustomerLocationsComponent implements OnInit {
  @Input() customer!: Customer;

  rowData: any[] = [];
  gridLoading = true;
  gridApi!: GridApi;
  notification = inject(NzNotificationService)

  theme = 'ag-theme-alpine';

  colDefs: ColDef[] = [
    { headerName: 'Partner Group ID', field: 'partner_group_id' },
    { headerName: 'Partner ID', field: 'partner_id' },
    { headerName: 'Partner Group', field: 'partner_group' },
    // {
    //   headerName: 'Partner Name',
    //   field: 'partner_name',
    //   editable: true,
    //   width: 250
    // },
    {
      headerName: 'Partner Name',
      field: 'partner_name',
      editable: true,
      cellRenderer: CellRendererComponent,
      cellEditor: CellEditorComponent,
      width: 250
    },
    { headerName: 'System Info', field: 'partner_system_info' },
    { headerName: 'Type', field: 'partner_type' },
    { headerName: 'Street', field: 'street' },
    { headerName: 'Street Number', field: 'street_no' },
    { headerName: 'Zip Code', field: 'zip_code' },
    { headerName: 'City', field: 'city' }
  ];

  defaultColDef: ColDef = {
    sortable: true,
    filter: true,
    resizable: true,
  };

  sideBar = {
    toolPanels: ['columns', 'filters'],
    defaultToolPanel: ''
  };

  gridOptions: GridOptions = {
    pagination: false,
    animateRows: true
  };

  constructor(private customerService: CustomersService) {}

  ngOnInit(): void {
    if (this.customer?.group_id) {
      this.loadLocations();
    } else {
      this.gridLoading = false;
    }
  }

  loadLocations(): void {
    this.customerService.getCustomerLocations(this.customer.pk).subscribe({
      next: (res) => {
        this.rowData = res || [];
        this.gridLoading = false;
      },
      error: (err) => {
        console.error(err);
        this.gridLoading = false;
      }
    });
  }

  onGridReady(params: any) {
    this.gridApi = params.api;
  }

  onCellValueChanged(event: CellValueChangedEvent) {
    if (event.colDef.field === 'partner_name') {
      const partnerId = event.data.partner_id;
      const newName = event.data.partner_name;
      event.data._saving = true;
      this.gridApi.refreshCells({ rowNodes: [event.node] });
      this.customerService.updatePartnerName(
        this.customer.pk,
        partnerId,
        { partner_name: newName }
      ).subscribe({
        next: () => {
          event.data._saving = false;
          this.gridApi.refreshCells({ rowNodes: [event.node] });
          this.notification.success("Success", "Partner name updated successfully");
        },
        error: (err) => {
          event.data._saving = false;
          event.node.setDataValue('partner_name', event.oldValue);
          this.gridApi.refreshCells({ rowNodes: [event.node] });
          this.notification.success("Error", "An error occurred");
          console.log(err)
        }
      });
    }
  }
}
